import type { InvoiceApi } from './adapter'
import { RealInvoiceApi } from './real'

export const invoiceApi: InvoiceApi = new RealInvoiceApi()

export type { InvoiceApi } from './adapter'
